export default "__VITE_ASSET__l_mq0YAl__"